import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      '& > div': {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    title: {
      color: palette.common.black,
      fontSize: '1.1rem',
      fontWeight: 600
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
